import { testimonials } from '@/mocks/data';

export default function Testimonials() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs md:text-sm text-primary-600 tracking-[0.2em] uppercase font-label mb-3">
            Testimonials
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            会员心声
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            来自精品八区会员的真实评价，他们的认可是我们不断前行的动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="p-6 rounded-lg bg-background-50 border border-background-200/60"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-sm text-primary-500" />
                ))}
              </div>
              <blockquote className="text-sm text-foreground-600 leading-relaxed mb-5">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}